import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
// import { allServices } from "../pages/servicesData";
import api from "../api";
import { toast } from "react-toastify";
import { loadServices } from "../pages/servicesDataStore";

const EnquiryPopup = ({ show, setShow }) => {
  const [services, setServices] = useState([]);

  // Load services once
  useEffect(() => {
    let isMounted = true;
    loadServices().then((data) => {
      if (isMounted) setServices(data);
    });
    return () => {
      isMounted = false;
    };
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    service: "",
    description: "",
  });

  const [errors, setErrors] = useState({});

  const categories = [
    ...new Set(services.map((service) => service.category)),
  ].filter((cat) => cat !== "All");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (value.trim() !== "") {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: `${capitalize(name)} is required`,
      }));
    }
  };

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const validate = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.service.trim()) newErrors.service = "Service is required";
    if (!formData.description.trim())
      newErrors.description = "Description is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validate()) return;

    api
      .post("submitEnquiryForm", formData)
      .then((res) => {
        toast.success(res.data.status.message || "Enquiry submitted!");
        setFormData({
          name: "",
          phone: "",
          email: "",
          service: "",
          description: "",
        });
        setShow(false);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to submit enquiry.");
      });
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Body className="p-4">
        <h4 className="mb-3 text-center">Service Enquiry Form</h4>
        <p className="mb-4">
          Fill out the form below and we'll get back to you within 24 hours.
        </p>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              placeholder="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              isInvalid={!!errors.name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Control
              type="tel"
              placeholder="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              isInvalid={!!errors.phone}
            />
            <Form.Control.Feedback type="invalid">
              {errors.phone}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Control
              type="email"
              placeholder="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              isInvalid={!!errors.email}
            />
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Select
              name="service"
              value={formData.service}
              onChange={handleChange}
              isInvalid={!!errors.service}
            >
              <option value="">Select Service Type</option>
              {categories.map((cat, idx) => (
                <option key={idx} value={cat}>
                  {cat}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.service}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Describe your needs"
              name="description"
              value={formData.description}
              onChange={handleChange}
              isInvalid={!!errors.description}
            />
            <Form.Control.Feedback type="invalid">
              {errors.description}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="outline-secondary" onClick={() => setShow(false)}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Submit Enquiry
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EnquiryPopup;
